import { render, staticRenderFns } from "./PreparesDaily.vue?vue&type=template&id=ee2e116e&scoped=true"
import script from "./PreparesDaily.vue?vue&type=script&lang=js"
export * from "./PreparesDaily.vue?vue&type=script&lang=js"
import style0 from "./PreparesDaily.vue?vue&type=style&index=0&id=ee2e116e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee2e116e",
  null
  
)

export default component.exports